// extracted by mini-css-extract-plugin
export default {"card":"Statements_card__6lqhy"};